/**
 * Function to check if a value is null or undefined
 * @param value value to check
 * @returns Boolean
 */
export const isNil = (value) => value === null || value === undefined
